import { CombinedGraphQLErrors, ErrorLike } from '@apollo/client';
import { GraphQLError, GraphQLFormattedError } from 'graphql';

import { ErrorCode } from '@/lib/apollo/types/gen/graphql';

export const getLastError = (
  error?: ErrorLike,
): GraphQLFormattedError | GraphQLError | undefined => {
  return CombinedGraphQLErrors.is(error)
    ? error.errors[error.errors.length - 1]
    : undefined;
};

export const getErrorCode = (
  graphQLError?: GraphQLFormattedError | GraphQLError,
): ErrorCode | undefined => {
  if (graphQLError?.extensions?.code) {
    const code = graphQLError?.extensions?.code;
    if (typeof code === 'string' && code in ErrorCode) {
      return graphQLError.extensions.code as ErrorCode;
    }
  }
  return undefined;
};
